const messages = {
    required: (field) => window.app.locales ? window.app.locales.validation.required.replace(":attribute", field) : 'The field is required',
    email: (field) => window.app.locales.validation.email.replace(":attribute", field),
    alpha_spaces: (field) => window.app.locales.validation.alpha_spaces.replace(":attribute", field),
    numeric: (field) => window.app.locales.validation.numeric.replace(":attribute", field),
    min_value: (field, [min]) => window.app.locales ? window.app.locales.validation.min_value.replace(":attribute", field).replace(":min", min) : 'Too low value',
    date_format: (field, [format]) => window.app.locales.validation.date_format.replace(":attribute", field).replace(":format", format),
    alpha_num: (field) => window.app.locales.validation.alpha_num.replace(":attribute", field),
    max_value: (field, [max]) => window.app.locales.validation.max_value.replace(":attribute", field).replace(":max", max),
    decimal: (field, [decimals]) => window.app.locales.validation.decimal.replace(":attribute", field).replace(":decimals", decimals),
    confirmed: (field) => window.app.locales.validation.confirmed.replace(":attribute", field),
    after: (field, [date]) => window.app.locales.validation.after.replace(":attribute", field).replace(":date", date),
    // after_or_equal: (field, [date]) => window.app.locales.validation.after_or_equal.replace(":attribute", field).replace(":date", date),
    alpha: (field) => window.app.locales.validation.alpha.replace(":attribute", field),
    before: (field, [date]) => window.app.locales.validation.before.replace(":attribute", field).replace(":date", date),
    // before_or_equal: (field, [date]) => window.app.locales.validation.before_or_equal.replace(":attribute", field).replace(":date", date),
    credit_card: (field) => window.app.locales.validation.credit_card.replace(":attribute", field),
    date_between: (field, [min, max]) => window.app.locales.validation.date_between.replace(":attribute", field).replace(":min", min).replace(":max", max),
    digits: (field, [digits]) => window.app.locales.validation.digits.replace(":attribute", field).replace(":digits", digits),
    dimensions: (field) => window.app.locales.validation.dimensions.replace(":attribute", field),
    ext: (field) => window.app.locales.validation.ext.replace(":attribute", field),
    image: (field) => window.app.locales.validation.image.replace(":attribute", field),
    included: (field) => window.app.locales.validation.included.replace(":attribute", field),
    integer: (field) => window.app.locales.validation.integer.replace(":attribute", field),
    ip: (field) => window.app.locales.validation.ip.replace(":attribute", field),
    length: (field, [length, max]) => window.app.locales.validation.length.replace(":attribute", field).replace(":length", length).replace(":max", max),
    mimes: (field, [values]) => window.app.locales.validation.mimes.replace(":attribute", field).replace(":values", values),
    excluded: (field) => window.app.locales.validation.excluded.replace(":attribute", field),
    regex: (field) => window.app.locales.validation.regex.replace(":attribute", field),
    url: (field) => window.app.locales.validation.url.replace(":attribute", field),
};

const locale = {
    name : 'validationDynamicLocale',
    messages
};

export default locale;


// WEBPACK FOOTER //
// ./resources/assets/js/dynamic-locale.js